declare namespace $ {

	type $mol_view__style_shm_hitalama_map_widget_float_layout_vert_1 = $mol_type_enforce<
		({ 
			'height': ReturnType< $shm_hitalama_map_widget_float_layout_vert['new_pos_height_px'] >,
			'top': ReturnType< $shm_hitalama_map_widget_float_layout_vert['new_pos_top_px'] >,
		}) 
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_widget_float_layout_vert_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $shm_hitalama_map_page_contextmenu__Map_page_shm_hitalama_map_widget_float_layout_vert_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_layout_vert['Map_page'] >
		,
		ReturnType< $shm_hitalama_map_page_contextmenu['Map_page'] >
	>
	type $shm_hitalama_map_page_contextmenu__widget_add_shm_hitalama_map_widget_float_layout_vert_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_layout_vert['contextmenu_widget_add'] >
		,
		ReturnType< $shm_hitalama_map_page_contextmenu['widget_add'] >
	>
	type $mol_pop_over__align_shm_hitalama_map_widget_float_layout_vert_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pop_over['align'] >
	>
	type $mol_pop_over__Anchor_shm_hitalama_map_widget_float_layout_vert_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_layout_vert['Add_to_container_anchor'] >
		,
		ReturnType< $mol_pop_over['Anchor'] >
	>
	type $mol_pop_over__bubble_content_shm_hitalama_map_widget_float_layout_vert_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pop_over['bubble_content'] >
	>
	type $mol_paragraph__title_shm_hitalama_map_widget_float_layout_vert_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_layout_vert['items_label'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_text__text_shm_hitalama_map_widget_float_layout_vert_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_layout_vert['item_title'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_list__sub_shm_hitalama_map_widget_float_layout_vert_10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_layout_vert['items'] >
		,
		ReturnType< $mol_list['sub'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_layout_vert_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_hitalama_map_widget_float_layout_vert extends $shm_hitalama_map_widget_float_group {
		arrange( ): any
		new_pos_height_px( ): string
		new_pos_top_px( ): string
		New_pos( ): $mol_view
		new_pos_visible( ): readonly(any)[]
		includes( ): string
		Add_to_container_anchor( ): $mol_button_minor
		contextmenu_widget_add( id: any): any
		Add_to_container_menu( ): $shm_hitalama_map_page_contextmenu
		Add_to_container( ): $mol_pop_over
		items_label( ): string
		Items_label( ): $mol_paragraph
		item_title( id: any): string
		Item( id: any): $mol_text
		items( ): readonly(any)[]
		Items( ): $mol_list
		gap( ): number
		padding_top( ): number
		padding_bottom( ): number
		padding_left( ): number
		padding_right( ): number
		add_types( ): readonly(any)[]
		tools_custom( ): readonly(any)[]
		auto( ): readonly(any)[]
		candidate_links( next?: readonly($giper_baza_link)[] ): readonly($giper_baza_link)[]
		candidate_pos( next?: number ): number
		candidates( next?: readonly($shm_hitalama_map_widget_any)[] ): readonly($shm_hitalama_map_widget_any)[]
		move_widgets_to_places( ): any
		controls( ): readonly(any)[]
		Includes( ): $mol_view
		contextmenu_body( ): readonly(any)[]
		settings_content( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=vert.view.tree.d.ts.map